import React from 'react'

import { Counter } from '@application/Interfaces/Atoms/Counter/Counter'
import { StatsType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'

import { Title, Value, Wrapper } from './Stats.styled'

export const Stats = ({ component, mode }: StatsType): JSX.Element => {
    return (
        <Wrapper $mode={mode}>
            <Container>
                <Grid container>
                    {component.map((c, i) => {
                        const hasComma = c.title.includes(',')

                        return (
                            <Grid
                                item
                                xs={12}
                                md={4}
                                key={`${i}-${c.title}`}
                                mdDownSpacingBottom={component.length - 1 === i ? 0 : 10}
                            >
                                <Title>
                                    {hasComma ? c.title : <Counter end={parseInt(c.title.replace(/[.+]/g, ''))} />}
                                </Title>
                                <Value>{c.value}</Value>
                            </Grid>
                        )
                    })}
                </Grid>
            </Container>
        </Wrapper>
    )
}
